const SCORE_COLORS = {
  green: 'rgb(0, 204, 102)',
  orange: 'rgb(255, 170, 51)',
  red: 'rgb(255, 51, 51)'
};

export function getGaugeColor(score: number) {
  if (score < 0.5) {
    return SCORE_COLORS.red;
  }

  if (score < 0.9) {
    return SCORE_COLORS.orange;
  }

  return SCORE_COLORS.green;
}
